export default {
    Email: '이메일',
    ConfirmEmail: '이메일 확인하기',
    Password: '비밀번호',
    Verificationcode: '검증코드',
    AlreadyhaveaHitPawaccountLogin: 'HitPaw 계정이 이미 있을까? 로그인',
    ByproceedingyouagreetoourServicesofUseandPrivacyPolicy1:
        '회원가입을 통해 귀하는 당사의 사용 서비스 및 개인 정보 보호 정책에 동의하는 것입니다.',
    ByproceedingyouagreetoourServicesofUseandPrivacyPolicy2:
        '로그인하면  귀하는 당사의 사용 서비스 및 개인 정보 보호 정책에 동의하는 것입니다.',
    Byproceedingyouagreetoour: '로그인하면  귀하는 당사의 사용 ',
    ServicesofUse: '서비스',
    and: ' 및 ',
    PrivacyPolicy: '개인 정보 보호 정책에',
    last: ' 동의하는 것입니다.',
    TheEmailformatisincorrect: '이메일 형식이 잘못되었습니다.',
    Pleaseenterthesameemailinbothfields: '두 번 입력한 메일함이 일치하지 않습니다.',
    Thepasswordmustbe850charactersandcontainatleasttwocategoriesamongthefollowingnumberletterorspecialcharacter:
        '비밀번호는 8-50자여야 하며 숫자, 문자 또는 특수 문자 중 두 개 이상 포함해야 합니다.',
    Incorrectverificationcode: '확인코드가 잘못되었습니다.',
    ThisEmailhasbeenregisteredpleasechooseanother:
        '등록된 이메일입니다. 다른 이메일을 선택하세요.',
    Cannotbeemptyhere: '여기는 비어 있을 수 없습니다.',
    Rememberme: '비밀번호 저장',
    ForgotPassword1: '비밀번호를 잊으셨습니까?',
    NotaregistereduseryetSignUp: '아직 등록된 사용자가 아니신가요? 로그인',
    Notaregistereduseryet1: '아직 등록된 사용자가 아니신가요? ',
    Notaregistereduseryet2: '로그인',
    NoaccountfoundwiththatEmailaddress: '해당 전자 메일 주소의 계정을 찾을 수 없습니다.',
    YourEmailaddressorpasswordwasincorrectPleasetryagain:
        '이메일 주소나 비밀번호가 틀렸습니다. 다시 시도하십시오.',
    ForgotPassword2: '비밀번호 잊어버림',
    GetVerificationCode: '인증번호 입력하기',
    VerifyEmail: '이메일 확인하기',
    Ithasbeensenttoyourmailboxpleasecheckit: '우편함으로 보내졌으니 확인해 주세요.',
    PleaseinputEmailaddress: '이메일 주소를 입력하십시오.',
    TheEmailisnotregistered: '이메일이 등록되지 않았습니다.',
    Invalidverificationcodepleasereenterthecorrectone:
        '잘못된 인증코드입니다. 올바른 코드를 다시 입력하십시오.',
    Resetpassword: '비밀번호 재설정하기',
    Emailaddressverificationsucceeded: '이메일 확인했습니다.',
    Pleaseresetyourpassword: '비밀번호를 재설정하십시오.',
    Enteranewpassword: '새 비밀번호 입력하기',
    Confirm: '확인하기',
    Newpasswordshouldbe850characterslongcomposedoflettersornumbersoramixtureoflettersnumbers:
        '새 비밀번호는 8-50문자가 필요하며, 영문 또는 숫자 또는 영문+숫자를 혼합하여 구성됩니다.',
    Passwordresetsuccessfully: '비밀번호 재설정 성공했습니다.',
    Name: '이름',
    GetCode: '인증번호 가져오기',
    Loginsuccessful: '로그인에 성공했습니다.',
    Loginfailed: '로그인에  실패했습니다.',
    Signupsuccessful: '성공적으로 등록했습니다.',
    Signupfailed: '가입하지 못했습니다.',
    Getpassword: '비밀번호를 가져옵니다.',
    Authorizationhasexpiredpleaseloginagain: '인증이 만료되었습니다. 다시 로그인하십시오.',
    Sorrysomethingwentwrongpleasetryagainlater:
        '죄송합니다. 문제가 발생했습니다. 다시 시도하십시오.',
    Toomanysamerequestsweremadeinashortperiodoftimepleasetryagainlater:
        '짧은 시간 동안 동일한 요청이 많았습니다. 잠시후 다시 시도하십시오.',
    Couldntfindyouraccountorthepasswordisincorrect:
        '계정을 찾을 수 없거나 비밀번호가 올바르지 않습니다.',
    Youaretryingtoaccessapaidfunctionpleasesubscribefirst:
        '유료 기능에 액세스하려면  먼저 가입하십시오.',
    Accessdeniedfortheunauthorizedrequest: '승인되지 않은 요청에 대한 액세스가 거부되었습니다.',
    Alreadyhaveaccount: '이미 계좌번호가 있습니까?',
    SignUpwithemail: '전자 우편으로 등록',
    Securityverification: '보안 검증',
    Pleaseenterthecorrectemailaddress: '정확한 이메일 주소를 입력하세요!',
    PleaseInputverificationCode: '인증번호를 입력하십시오!',
    Pleaseenterthesamepasswordinbothfields: '비밀번호가 두 번 입력이 일치하지 않습니다!',
    or: '또는',
    ThenewpasswordyouenteredisthesameasyouroldpasswordEnteradifferentpassword:
        '입력한 새 비밀번호가 이전 비밀번호와 동일합니다. 다른 비밀번호 입력하십시오.',
    YourpasswordwasincorrectPleasetryagain: '비밀번호가 올바르지 않습니다. 다시 시도하십시오.',
    reg400: '죄송합니다. 문제가 발생했습니다. 다시 시도하십시오.',
    reg400223: '이메일과 인증번호가 일치하지 않습니다. 확인하세요.',
    reg400224: '토큰 만료됨',
    500: '서버 측 오류!',
    Afewsecondsaway: '빠른 로그인 또는 등록',
    ContinuewithGoogle: 'Google로 계속 진행',
    ContinuewithEmail: 'Email로 계속 진행',
    LoginwithEmail: 'Email로 로그인하기',
    Usemorethan8charactersandmixlettersnumbersandsymbols:
        '문자, 숫자 및 기호를 혼합하여 8자 이상 사용합니다(기호 지원:@$!%*#_~?&^)',
    ConfirmPassword: '비밀번호 확인하기',
    Pleaseloginwithemail: 'Email로 로그인하세요',
    youraccount: '고객님의 계정',
    alreadyexiststoensurethesecuritypleaseverifyitfirst:
        '은 이미 존재합니다. 계정의 안전성을 확보하기 위해 먼저 인증을 완료해 주세요.',
    Login: '로그인',
    exceed6Times: '평가판이 오늘 만료되었습니다. 모든 프리미엄 기능에 액세스하려면 Pro로 업그레이드하십시오.',
    exceed20M: '무료 계정의 파일 크기는 20MB를 초과할 수 없습니다. 모든 프리미엄 기능에 액세스하려면 Pro로 업그레이드하십시오.'
}